import { Children } from 'react';
import { ImageAtoms } from '@vfit/shared/atoms';
import { Check } from '@vfit/shared-icons';
import { IPropositionCardProps } from './propositionCard.models';
import {
  BottomContainer,
  ListItem,
  LogoContainer,
  Price,
  PriceContainer,
  PriceRecurrenceContainer,
  Recurrence,
  Subprice,
  TopContainer,
  Wrapper,
} from './propositionCard.style';
import { purify } from '@vfit/shared/themes';
import { purifyTextWithLogo } from '@vfit/shared/data-access';

const PropositionCard = ({
  price,
  recurrence,
  subprice,
  cornerColor,
  cornerImage,
  items,
}: IPropositionCardProps) => {
  const havePrice = !!price && !!recurrence;
  return (
    <Wrapper havePrice={havePrice}>
      <TopContainer className="proposition-card-top-container">
        {havePrice && (
          <PriceContainer>
            <PriceRecurrenceContainer>
              <Price dangerouslySetInnerHTML={{ __html: price || '' }} />
              {recurrence && <Recurrence dangerouslySetInnerHTML={{ __html: recurrence || '' }} />}
            </PriceRecurrenceContainer>
            <Subprice dangerouslySetInnerHTML={{ __html: subprice || '' }} />
          </PriceContainer>
        )}
        <LogoContainer color={cornerColor}>
          <ImageAtoms
            image={cornerImage}
            nameCard="cornerImage"
            style={{
              objectFit: 'contain',
              width: '100%',
              paddingTop: 8,
              paddingBottom: 8,
            }}
          />
        </LogoContainer>
      </TopContainer>
      <BottomContainer havePrice={havePrice} className="proposition-card-bottom-container">
        {items &&
          Children.toArray(
            items?.map((item, index) => {
              const [pItem] = purify([item], purifyTextWithLogo);
              if (!pItem) return <></>;
              return (
                <ListItem isBold={index === 0}>
                  <Check />
                  <span dangerouslySetInnerHTML={{ __html: pItem || '' }} />
                </ListItem>
              );
            })
          )}
      </BottomContainer>
    </Wrapper>
  );
};

export default PropositionCard;
